import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../services/commonServices/apiService";
import AuthDetailsService from "../../services/authDetailsService";
const AuthService: AuthDetailsService = new AuthDetailsService(ApiService);
export const getAuthDetails = createAsyncThunk(`auth/getData`, async () => {
  const res = await AuthService.getData();
  return res;
});
